function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLabometintegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 80,
    viewBox: "0 0 150 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6787 21.0977V40.8178H91.7792L91.8886 27.6038C91.8886 28.3267 92.8735 33.3366 93.0194 34.1604C93.1653 35.0178 94.1684 40.0949 94.1684 40.8178H97.5241L98.0713 37.4723C98.2537 36.4299 99.6762 28.125 99.6762 27.3852L99.8039 40.8346H103.16V21.0977C103.16 20.8455 103.069 20.7614 102.795 20.7614H98.6002C98.1442 20.7614 98.2172 21.2826 98.0531 22.2409L97.1959 27.5029C96.977 28.7302 96.8311 29.8061 96.6305 31.0502C96.4481 32.1261 96.1016 33.5383 96.1016 34.6311C95.7551 34.1772 94.8432 28.2258 94.7337 27.6206C94.5149 26.3933 94.3325 25.3342 94.1319 24.107C94.0042 23.4345 93.9313 22.9806 93.8036 22.3081C93.4206 20.2403 94.4419 20.7278 89.0617 20.7278C88.7881 20.7278 88.697 20.795 88.697 21.064L88.6787 21.0977Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3518 27.2688C66.209 26.8485 72.0269 23.5702 72.3005 23.5534C72.6835 23.5366 75.3645 25.0329 75.8752 25.285L79.4681 27.1511V32.7831C79.4681 33.5564 79.5775 33.8926 79.5775 34.5483L76.1123 36.4144C75.711 36.633 72.7382 38.2973 72.5376 38.2973C72.1546 38.2973 66.2637 34.935 65.4795 34.7669C65.4795 32.1442 65.3701 29.7738 65.3701 27.2688H65.3518ZM62.1237 25.7221C62.1237 27.1175 62.0508 35.4225 62.1967 36.1286C62.3608 36.8347 62.5797 36.633 64.0205 37.4231C64.2758 37.5744 64.4217 37.6248 64.7135 37.7761L70.8232 40.9536C73.0483 42.1976 72.3735 41.9286 74.9086 40.6005C75.3463 40.3652 75.784 40.113 76.2399 39.8608L80.2341 37.7089C80.7447 37.4231 81.1095 37.2214 81.6019 36.986C81.8755 36.8347 82.8056 36.448 82.8056 36.1118V30.0428C82.8056 28.328 82.6779 26.9998 82.6779 25.3019L72.9388 20.2583C72.1181 19.7876 72.3917 19.9725 70.9327 20.7123L63.2545 24.8816C62.8715 25.0833 62.1237 25.3187 62.1237 25.7053V25.7221Z",
    fill: "#3C79B6",
    style: {
      fill: "#3C79B6",
      fill: "color(display-p3 0.2353 0.4745 0.7137)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.473 37.9454H50.2875V31.8764C54.0992 31.8764 53.8804 31.7923 53.8804 36.3987C53.8804 37.7269 52.932 37.9454 51.4912 37.9454H51.473ZM51.7283 28.9175H50.2875V23.7227H51.9654C53.3332 23.7227 53.6433 24.8827 53.6433 26.1604C53.6433 27.7071 53.4244 28.9175 51.7283 28.9175ZM46.8223 40.8202C48.8467 40.8202 53.0414 41.0388 54.6646 40.4504C55.23 40.2486 55.9595 39.7947 56.2878 39.408C57.2362 38.2985 57.455 37.088 57.455 35.2051C57.455 33.3222 57.0538 30.6996 54.9564 30.2457C55.3577 29.7245 57.1085 29.4387 57.1085 25.841C57.1085 19.9401 52.7861 20.7639 46.8223 20.7639V40.8202Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3507 24.8323L35.4419 25.0676C35.7884 26.4798 36.7732 33.9442 37.0286 34.415H33.8004C33.8004 33.961 33.8916 33.7089 33.9828 33.2549C34.3111 31.3552 34.9859 26.2949 35.3689 24.8323H35.3507ZM29.478 40.8202H32.7062C32.7791 39.9796 33.2715 37.8782 33.2898 37.1889H37.4663C37.4663 38.433 37.9587 39.5593 37.9587 40.8202H41.5334L39.7643 30.6659C39.4542 28.968 39.1624 27.3372 38.8888 25.6224L38.2323 21.823C37.9952 20.4108 38.6153 20.7638 33.2898 20.7638C32.7791 20.7638 32.7609 22.1088 32.615 22.9998L29.478 40.8202Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.233 40.8189H118.334C118.954 40.8189 118.698 39.5748 118.698 37.9609H112.716V32.1272H117.367V29.2692H112.716V23.755H118.334C118.936 23.755 118.698 22.679 118.698 21.1155C118.698 20.8634 118.607 20.7793 118.334 20.7793H109.233V40.8357V40.8189Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.349 21.098C123.349 22.6614 123.094 23.7374 123.714 23.7374H126.942V40.8181H130.407V23.7374H134V20.7617H123.714C123.44 20.7617 123.349 20.829 123.349 21.098Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2007 40.8181H25.3014V37.9601H19.6659V21.098C19.6659 20.8458 19.593 20.7617 19.3011 20.7617H16.2007V40.8181Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 50.9893H17.459V56.2345L21.7632 50.9893H23.1493V58.3696H21.6903V53.1412L17.3861 58.3696H16V50.9893Z",
    fill: "#808080",
    fillOpacity: 0.55,
    style: {
      fill: "#808080",
      fill: "color(display-p3 0.5020 0.5020 0.5020)",
      fillOpacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3718 50.9893V58.3696H34.8763V55.209H30.7362V58.3696H29.2407V50.9893H30.7362V54.0322H34.8763V50.9893H36.3718Z",
    fill: "#808080",
    fillOpacity: 0.55,
    style: {
      fill: "#808080",
      fill: "color(display-p3 0.5020 0.5020 0.5020)",
      fillOpacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3353 52.1493H45.6726V58.3696H44.1953V52.1493H41.5508V50.9893H48.3171V52.1493H48.3353Z",
    fill: "#808080",
    fillOpacity: 0.55,
    style: {
      fill: "#808080",
      fill: "color(display-p3 0.5020 0.5020 0.5020)",
      fillOpacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4798 57.2264V58.3696H53.4795V50.9893H59.3339V52.1325H54.975V54.049H58.8415V55.1754H54.975V57.2096H59.498L59.4798 57.2264Z",
    fill: "#808080",
    fillOpacity: 0.55,
    style: {
      fill: "#808080",
      fill: "color(display-p3 0.5020 0.5020 0.5020)",
      fillOpacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3861 52.1493H66.4102V58.3696H64.9512V50.9893H70.3861V52.1493Z",
    fill: "#808080",
    fillOpacity: 0.55,
    style: {
      fill: "#808080",
      fill: "color(display-p3 0.5020 0.5020 0.5020)",
      fillOpacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5627 51.3087C81.0734 51.5272 81.4746 51.8298 81.7482 52.2165C82.0217 52.6032 82.1676 53.0739 82.1676 53.6119C82.1676 54.1499 82.0217 54.6206 81.7482 55.0073C81.4746 55.3939 81.0734 55.7134 80.5627 55.9151C80.052 56.1168 79.4502 56.2345 78.7571 56.2345H76.9516V58.3696H75.4561V50.9893H78.7571C79.4502 50.9893 80.052 51.0901 80.5627 51.3087ZM80.1615 54.7046C80.4897 54.4525 80.6721 54.0826 80.6721 53.6119C80.6721 53.1412 80.508 52.7713 80.1615 52.5191C79.8332 52.2669 79.3408 52.1325 78.6842 52.1325H76.9516V55.0577H78.6842C79.3408 55.0577 79.8149 54.9232 80.1615 54.671V54.7046Z",
    fill: "#808080",
    fillOpacity: 0.55,
    style: {
      fill: "#808080",
      fill: "color(display-p3 0.5020 0.5020 0.5020)",
      fillOpacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.98 56.6548H87.9676L87.1834 58.3696H85.6514L89.2625 50.9893H90.7215L94.3327 58.3696H92.7824L91.98 56.6548ZM91.4875 55.5789L89.9738 52.351L88.4783 55.5789H91.4875Z",
    fill: "#808080",
    fillOpacity: 0.55,
    style: {
      fill: "#808080",
      fill: "color(display-p3 0.5020 0.5020 0.5020)",
      fillOpacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.92 57.2096V60.0003H106.552V58.3696H99.749V50.9893H101.208V57.2096H105.239V50.9893H106.716V57.2096H107.901H107.92Z",
    fill: "#808080",
    fillOpacity: 0.55,
    style: {
      fill: "#808080",
      fill: "color(display-p3 0.5020 0.5020 0.5020)",
      fillOpacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.482 50.9893H114.941V56.2345L119.246 50.9893H120.632V58.3696H119.173V53.1412L114.869 58.3696H113.482V50.9893Z",
    fill: "#808080",
    fillOpacity: 0.55,
    style: {
      fill: "#808080",
      fill: "color(display-p3 0.5020 0.5020 0.5020)",
      fillOpacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.87 50.9914V58.3718H131.411V56.3207H129.277L127.781 58.3718H126.213L127.927 56.1022C127.38 55.9173 126.942 55.6146 126.632 55.1944C126.322 54.7909 126.176 54.2865 126.176 53.6981C126.176 53.1097 126.322 52.6558 126.596 52.2355C126.869 51.8152 127.252 51.5126 127.763 51.294C128.274 51.0755 128.857 50.9746 129.532 50.9746H132.87V50.9914ZM128.182 52.5381C127.854 52.7903 127.69 53.1769 127.69 53.6813C127.69 54.1856 127.854 54.5387 128.164 54.8077C128.474 55.0767 128.93 55.2112 129.532 55.2112H131.411V52.1682H129.587C128.985 52.1682 128.511 52.3027 128.182 52.5549V52.5381Z",
    fill: "#808080",
    fillOpacity: 0.55,
    style: {
      fill: "#808080",
      fill: "color(display-p3 0.5020 0.5020 0.5020)",
      fillOpacity: 0.55
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLabometintegration);
export default __webpack_public_path__ + "static/media/logo_Labomet integration.00aab36043980d0e9e1079582e715bd8.svg";
export { ForwardRef as ReactComponent };